import { defineStore } from 'pinia';
import { delay } from '🔗/utils/utils';
// import api from '🔗/api';
// import stores from '🔗/stores';
import router from '@/router';

const themes = import.meta.env.VITE_APP_THEMES ? import.meta.env.VITE_APP_THEMES.split(',') : [];

const useUserStore = defineStore('user', {
    state: () => ({
        theme: themes?.length ? (localStorage['theme'] && themes.includes(localStorage['theme']) ? localStorage['theme'] : null) : null,
        profile: {},
        token: null,

        artists : [],

        externalToken: null,
        externalCode: null
    }),
    getters: {
        artistsIds: (state) => state.artists.map(item => item.id),

        isArtist: (state) => !!state.artists?.length,
        isAdmin: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'admin');
        },
        isArtistCurator: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'artist_curator');
        },
        isTrackCurator: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'track_curator');
        },
        isDictionaryCurator: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'dictionary_curator');
        },
        isPlaylistCurator: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'playlist_curator');
        },
        isShowcaseCurator: (state) => {
            return !!state.profile?.roles?.find(role => role.roleId === 'showcase_curator');
        },
        providers: (state) => {
            return state.profile?.providers?.map(item => item.provider) || []
        }
    },
    actions: {
        setTheme(theme) {
            this.theme = theme;

            if (theme) {
                localStorage['theme'] = theme;
            } else {
                delete localStorage['theme'];
            }
        },
        async login() {
            const payload = await stores.messengers().getLoginData();

            let data;

            if (stores.messengers().code === 'tg') {
                data = await api.user().tglogin(payload);
            }

            if (stores.messengers().code === 'max') {
                data = await api.user().maxlogin(payload);
            }

            if (!data.user?.profileImage) {
                data.user.profileImage = stores.messengers().getDefaultProfileImage();
            }

            this.token = data?.token;
            this.profile = data?.user || {};
        },
        async getArtists() {
            if (this.artists?.length)
                return this.artists;

            const data = await api.user().getMyArtists({ skip: 0, take: 200 }); // ToDo Total

            if (data?.items) {
                this.artists = data.items;
            }

            return this.artists;
            
        },
        async me() {
            const data = await api.user().getMyProfile();

            if (data && !data?.profileImage) {
                data.profileImage = stores.messengers().getDefaultProfileImage();
            }

            if (data?.id) {
                this.profile = data;
            }
        },
        async updateAvatar(file) {
            if (!file) {
                return;
            }

            const data = await api.user().updateMyAvatar(file);

            if (data?.id) {
                this.profile = data;
            }
        },
        async updateFirstName(firstName) {
            if (!firstName?.trim().length) {
                return;
            }

            const data = await api.user().updateMyProfile({
                firstName
            });

            if (data?.id) {
                this.profile = data;
            }
        },
        async createExternalLogin() {
            const data = await api.user().createExternalLogin();
            this.externalCode = data?.value;
            this.externalToken = data?.token;
        },
        async checkExternalLogin() {
            const { $cookies } = router.app.config.globalProperties;

            const data = await api.user().checkExternalLogin({
                value: this.externalCode,
                token: this.externalToken
            });

            if (!data?.token) {
                return false;
            }

            $cookies.set('auth._token', data?.token);

            this.token = data?.token;
            this.profile = data?.user || {};

            return true;
        },
        async externalLogin(value) {
            return await api.user().authExternalLogin({
                value
            });
        },
        async checkHasToken() {
            const { $cookies } = router.app.config.globalProperties;

            if (!this.token) {
                this.token = $cookies.get('auth._token');
                if (this.token) {
                    await this.me();
                    await this.getArtists();
                }
            }

            return !!this.token;
        },
        logout() {
            const { $cookies } = router.app.config.globalProperties;

            $cookies.remove('auth._token');
            this.token = null
        }
    }
});

export default useUserStore;
